.container {
  display: grid;
  gap: 8px;
}

.formTitle {
  font-size: var(--font-size-lg);
  font-weight: 700;
}

.header {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.popupHintOverride {
  gap: 8px;
}

.popupHintText {
  font-size: var(--font-size-sm);
  color: var(--color-text-link);
}

.rows {
  display: grid;
  gap: 16px;

  @media screen and (width >= 769px) {
    gap: 0;
  }
}

.publicNotice {
  font-size: var(--font-size-sm);
}

.link {
  color: var(--color-text-link);

  &:hover {
    text-decoration: underline;
  }
}

.textXs {
  font-size: var(--font-size-xs);
}

.sizedInput {
  @media screen and (width >= 769px) {
    width: 380px;
  }
}

.phoneNumberField {
  display: flex;
  gap: 4px;
  align-items: center;
  width: 272px;

  @media screen and (width >= 600px) {
    gap: 16px;
    width: 314px;
  }
}

.presentation {
  user-select: none;
}

.nameField {
  display: flex;
  flex-direction: column;
  gap: 8px;

  @media screen and (width >= 600px) {
    flex-direction: row;
    gap: 24px;
  }

  div {
    display: grid;
    gap: 8px;
    height: min-content;

    label {
      display: grid;
      gap: 8px;

      @media screen and (width >= 600px) {
        grid-template-columns: 31px 140px;
      }

      span {
        align-self: center;
        font-size: var(--font-size-xs);
      }
    }
  }
}

.srOnly {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  white-space: nowrap;
  border-width: 0;
  clip-path: inset(100%);
}
